import React, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { adminHttp } from "~/Admin/services/http";
import { connect } from "react-redux";
import { EditIcon } from '../../../Components/Icons/Icons';
import { DebounceInput } from 'react-debounce-input';
import ValidationError from '../../../Components/Forms/ValidationError';
import { toast } from 'react-toastify';

const AdminEditInvitationDetails = ({ guest, invitationUser, event, onChange, dispatch, ...rest }) => {

    const [show, setShow] = useState(false);
    const [error, setError] = useState(null);
    const [languages, setLanguages] = useState(null);
    const [waves, setWaves] = useState([]);
    const [packages, setPackages] = useState([]);
    const [departments, setDepartments] = useState([]);

    useEffect(() => {
        setForm({
            wave_id: guest?.wave_id,
            package_id: guest?.package_id,
            language_id: invitationUser?.language_id,
            neom_department_id: guest?.neom_department_id,
            guest_allowance: guest?.guest_allowance,
        })
    }, [guest])

    const [form, setForm] = useState({
        wave_id: guest?.wave_id || '',
        package_id: guest?.package_id || '',
        language_id: invitationUser?.language_id || '',
        neom_department_id: guest?.neom_department_id || '',
        guest_allowance: guest?.guest_allowance || '',
    });

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const handleSubmit = () => {
        toast.promise(
            adminHttp.post(`/events/${event.id}/invitations/${guest.id}/edit-guest`, form),
            {
                pending: 'Saving Invitation...',
                success: {
                    render() {
                        setError(null);
                        setShow(false);
                        onChange();
                        return 'Invitation details saved'
                    }
                },
                error: {
                    render(error) {
                        setError(error.data?.response?.data?.errors);
                        return 'Something went wrong!'
                    }
                }
            }
        )
    };

    const loadWaves = () => {
        adminHttp
            .get(`/events/${event.id}/waves`)
            .then(res => setWaves(res.data));
    };

    const loadPackages = () => {
        adminHttp
            .get(`/events/${event.id}/packages`)
            .then(res => setPackages(res.data));
    };

    const loadDepartments = () => {
        adminHttp
            .get(`/neom-departments`)
            .then(res => setDepartments(res.data.data))
    }

    const loadlanguages = () => {
        adminHttp
            .get(`/languages`)
            .then(res => {
                setLanguages(res.data.data)
            })
    }

    useEffect(() => {
        loadWaves();
        loadPackages();
        loadDepartments();
        loadlanguages();
    }, []);

    if (!guest) {
        return <></>;
    }

    return (
        <>
            <span {...rest} onClick={handleShow}><EditIcon /></span>

            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Invitation Details</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div>
                        <p className="mb-0">Wave</p>
                        <select
                            name="wave_id"
                            defaultValue={guest?.wave_id || 0}
                            onChange={(e) => setForm({ ...form, wave_id: +e.target.value })}
                            className="form-control"
                        >
                            <option value={undefined}>Wave</option>
                            {waves.map((wave) => (
                                <option key={wave.id} value={wave.id}>
                                    {wave.name}
                                </option>
                            ))}
                        </select>
                        <ValidationError errors={error} name="wave_id" />
                    </div>

                    <div className="mt-2">
                        <p className="mb-0">Package</p>
                        <select
                            name="wave_id"
                            defaultValue={guest?.package_id || 0}
                            onChange={(e) => setForm({ ...form, package_id: +e.target.value })}
                            className="form-control"
                        >
                            <option value={undefined}>Package</option>
                            {packages.map((p) => (
                                <option key={p.id} value={p.id}>{p.name}</option>
                            ))}
                        </select>
                        <ValidationError errors={error} name="package_id" />
                    </div>

                    <div className="mt-2">
                        <p className="mb-0">Language</p>
                        <select
                            name="language_id"
                            defaultValue={invitationUser?.language_id || 0}
                            onChange={(e) => setForm({ ...form, language_id: +e.target.value })}
                            className="form-control"
                        >
                            <option value={0} disabled>Language</option>
                            {
                                languages?.map((lang, index) => {
                                    return <option key={index} value={lang.id}>{lang.name}</option>
                                })
                            }
                        </select>
                        <ValidationError errors={error} name="language_id" />
                    </div>

                    <div className="mt-2">
                        <p className="mb-1">Number of Invitees</p>
                        <DebounceInput
                            onChange={(e) => setForm({ ...form, guest_allowance: +e.target.value })}
                            className="form-control mr-4"
                            name="numberOfInvitees"
                            type="number"
                            value={guest?.guest_allowance || 0}
                            placeholder="Number of Invitees"
                        />
                        <ValidationError errors={error} name="guest_allowance" />
                    </div>

                    <div className="mt-2">
                        <p className="mb-1">NEOM Department</p>
                        <select
                            name="wave_id"
                            defaultValue={guest?.neom_department_id || 0}
                            onChange={(e) => setForm({ ...form, neom_department_id: +e.target.value })}
                            className="form-control"
                        >
                            <option value={undefined}>Department</option>
                            {departments.map((department) => (
                                <option key={department.id} value={department.id}>{department.name}</option>
                            ))}
                        </select>
                        <ValidationError errors={error} name="neom_department_id" />
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <div className="w-100 text-center">
                        <div className="btn btn-sm btn-secondary" onClick={handleSubmit}>OK</div>
                    </div>
                </Modal.Footer>
            </Modal>
        </>
    );
}

const mapStateToProps = (state) => ({
    user: state.auth?.user,
    event: state.event.current,
});

export default connect(mapStateToProps)(AdminEditInvitationDetails);
